import axios, { AxiosRequestConfig } from 'axios';

import { AxiosServiceResponse, PagedList } from 'interfaces/general';

import { IParamsFilter } from './catalog';

const instance = axios.create({
  baseURL: `${process.env.PRODUCTS_SERVICE_ENDPOINT}/api/v1`,
  headers: {
    // SE ELIMINARIA CUANDO SE TENGA QA ESTABLE API KEY
    // 'Api-key': process.env.REQUEST_HEADER_API_KEY,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

/* REQUESTS */

/* RESPONSES */

export interface GetParamsProduct {
  OriginResponsibleId: number;
  DestinyResponsibleId: number;
  PageNumber: number;
  PageSize: number;
  Text?: string;
  Descending?: boolean;
  OrderColumn?: string;
}

export interface Product {
  stockNumber?: unknown;
  id: number;
  currencyId: number;
  currencyName: string;
  clientId: number;
  clientName: string;
  productModelId: number;
  productModelName: string;
  productStateId: number;
  productStatusName: string;
  productModelDescription: string;
  serialNumber: string;
  cost: number;
  productConditionId: number;
  productConditionName: string;
  simNumber: string | null;
  imeiNumber: string | null;
  productBrandingId: number;
  productBrandingName: string;
  productModelSKU?: string;
  equipmentNumber?: string;
  responsibleName?: string;
  modelLogoLink?: string;
  createdDate?: Date;
  instaledDate?: Date;
  withdrawnDate?: Date;
}

export interface ProductPost {
  clientId: number;
  responsibleId: number;
  productStatusId: number;
  productConditionId: number;
  productModelId: number;
  productBrandId?: number;
  serialNumber: string;
  responsibleTypeId?: number;
  simNumber?: string;
  imeiNumber?: string;
  cost: number;
  currencyId: number;
  equipmentNumber: string;
  isClientProperty?: boolean;
  ipAddress?: string;
  portNumber?: string;
  comment?: string;
  stockNumber?: string;
  hasAdvancedSearch?: boolean;
}

export interface ProductMassiveLoad {
  products: ProductBulkLoad[];
  withoutSaving: boolean;
}

export interface ProductBulkLoad {
  index: number;
  clientName: string;
  responsibleTypeName: string;
  responsibleName: string;
  productModelId: number;
  serialNumber: string;
  stockNumber: string;
  currencyId: number;
  cost: number;
  equipmentNumber: string;
  isClientProperty: boolean;
  simNumber: string;
  imeiNumber: string;
  ipAddress: string;
  portNumber: string;
  comment: string;
}

export interface IBulkIntake {
  index?: number;
  serialNumber: string;
}

export interface ProductMassiveUpdate {
  id: number;
  clientName: string;
  responsibleTypeName: string;
  responsibleName: string;
  productModelId: number;
  serialNumber: string;
  stockNumber: string;
  currencyId: number;
  cost: number;
  equipmentNumber: string;
  isClientProperty: boolean;
  simNumber: string;
  imeiNumber: string;
  ipAddress: string;
  portNumber: string;
  comment: string;
}

export interface ErrorProduct {
  index?: number;
  errorMsg: string;
  serialNumber: string;
}

export interface AddedProduct {
  currencyId: number;
  cost: number;
  isClientProperty: boolean;
  serialNumber: string;
  simNumber: string;
  imeiNumber: string;
  stockNumber: string;
  equipmentNumber: string;
  portNumber: string;
  comment: string;
  index: number;
  clientName: string;
  responsibleTypeName: string;
  responsibleName: string;
  ipAddress: string;
  successProductId: number;
  productModelName: string;
  productBrandName: string;
  createdDate: string;
}

export interface BulkLoadProductsResponse {
  addedProducts: AddedProduct[];
  errorProducts: ErrorProduct[];
  createdDateTimeUTC: string;
}

export interface ProductSearched {
  id: number;
  responsibleType?: number;
  responsibleTypeName?: string;
  clientId?: number;
  clientName?: string;
  locationId?: number;
  locationName?: string;
  responsibleId?: number;
  responsibleName?: string;
  productStatusId?: number;
  productStatusName?: string;
  productBrandId?: number;
  productBrandName?: string;
  productModelId?: number;
  productModelName?: string;
  description?: string;
  serialNumber: string;
  stockNumber?: string;
  isClientProperty?: boolean | string;
  ipAddress?: string;
  portNumber?: string;
  equipmentNumber?: string;
  addDate?: string;
  productConditionId?: number;
  productConditionName?: string;
  simNumber?: string;
  imei?: string;
  cost?: number;
  currencyId?: number;
  currencyName?: string;
  productModelDescription?: string;
  comment?: string;
  installedDate?: string;
  lastMovementDate?: string;
  lastMovementType?: string;
  sku?: string;
  withdrawnDate?: string;
  kitCI?: string;
  enabled?: boolean;
  qty?: string;
  kitName?: string;
  kitId?: number;
  dynamicFormFields?: { formFieldId: string | number; value: string }[];
  dynamicFormFieldsKeyVault?: { [key: string]: string };
}

export interface ProductPut extends ProductPost {
  productId?: number;
  changeReason?: string;
}

export interface SearchProductsByClientParams {
  reportType?: string;
  productIds?: number[];
  clientId?: number;
  responsibleTypeId?: number;
  responsibleId?: number;
  warehouseId?: number;
  engineerId?: number;
  locationId?: number;
  productStatusId?: number[];
  productConditionId?: number[];
  hasAdvancedSearch?: boolean;
  field?: string;
  equals?: boolean | string;
  contains?: string;
  enabled?: boolean;
  pageNumber?: number;
  pageSize?: number;
  valueToSearch?: string;
  text?: string;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  value?: string;
  textType?: number;
  search?: string;
  DynamicFieldValue?: string;
  FormFieldId?: number | string;
  offset?: number;
  onlySearch: boolean;
}

export interface ProductItem {
  id: number;
  value: string;
}

export interface SearchProductsByClientResponse {
  productId?: number;
  serialNumber?: string;
  clientId?: number;
  client?: string;
  productBrand?: string;
  productModel?: string;
  clientName?: string;
  productBrandName?: string;
  productModelName?: string;
  productModelDescription?: string;
}

export interface GeoProductsResponse {
  producId: number;
  latitude: number;
  longitude: number;
}

export interface GeoProductsRequest {
  responsibleId?: number | null;
  clientId?: number | null;
  statusId?: number | null;
  statusIds?: number[] | null;
  conditionIds?: number[] | null;
  stateIds?: number[] | null;
  text?: string | null;
}

export interface TicketsByLocationParams {
  productId?: number;
  TicketId?: number;
  ServiceName?: string;
  LocationName?: string;
  AssignedEngineerEmail?: string;
  TicketsStatusIds?: number[];
  OrderColumn?: string;
  Descending?: string;
  PageNumber?: number;
  PageSize?: number;
  Text?: string;
  IsExport?: boolean;
}

export interface TicketsByLocationResponse {
  ticketId: number;
  serviceType: string;
  service: string;
  serialNumber: string;
  assignedEngineer: string;
  ticketStatus: string;
  closedDate: string;
}

export interface IConfigComponentLoogBook {
  createdDate: Date;
  user: string;
  userName: string;
  actionType: string;
  changeReason: string;
  updatedFields: string;
}

export interface SuppliesOriginalRequest {
  supplyId?: number;
  name?: string;
  unitMeasurementId?: number;
  currencyId?: number;
  cost?: number;
  enabled?: boolean;
}

export interface SearchSuppliesParams {
  pageNumber?: number;
  pageSize?: number;
  text?: string;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  unitMeasurementId?: number;
  currencyId?: number;
  enabled?: boolean;
}

export interface GeneralSearchKitResponse {
  kitId?: number;
  clientId?: number;
  client?: string;
  responsibleTypeId?: number;
  responsibleType?: string;
  responsibleId?: number;
  responsible?: string;
  kitName?: string;
  kitStatusId?: number;
  canEditKit?: boolean;
  kitStatus?: string;
  productsCount?: number;
}

export interface NewKitRequest {
  clientId: number;
  name: string;
  responsibleId: number;
}

export interface AddNewConfigComponentsToAKit {
  kitId: number;
  productIds: number[];
}

export interface DeleteConfigComponentsToAKit {
  kitId: number;
  productIds: number;
}

export interface EditKitRequest {
  kitId?: number;
  clientId?: number;
  name: string;
  responsibleId: number;
}

export interface KitProductRequest {
  kitId?: number;
  kitName?: string;
  productId?: number;
  clientId?: number;
  serialNumber?: string;
  productBrandId?: number;
  productBrand?: string;
  productModelId?: number;
  productModel?: string;
  productStatusId?: number;
  productStatus?: string;
  productConditionId?: number;
  productCondition?: null;
}
export interface AllProductForAKitResponse {
  productId?: number;
  clientId?: number;
  serialNumber?: string;
  productBrandId?: number;
  productBrand?: string;
  productModelId?: number;
  productModel?: string;
  productStatusId?: number;
  productStatus?: string;
  productConditionId?: number;
  productCondition?: string;
}

export interface KitLoogBookParams {
  KitId?: number;
  PageNumber?: number;
  PageSize?: number;
  Text?: string;
  OrderColumn?: number | string;
  Descending?: boolean;
  IsExport?: boolean;
}

export interface KitLoogBookResponse {
  id?: number;
  kitId?: number;
  initialStatus?: string;
  finalStatus?: string;
  responsibleType?: string;
  responsible?: string;
  createdDateTime?: Date;
  kitName?: string;
}

export interface KitStatusResponse {
  id: number;
  name: string;
  enabled: boolean;
}

export interface SupplyForTicket {
  supplyId: number;
  supplyName: string;
  unitMeasurementName: string;
  quantity: number;
}

export interface ProductForTicket {
  productId: number;
  serialNumber: string;
  brandName: string;
  modelName: string;
  modelDescription: string;
  clientName: string;
  operationTypeId: number;
  operationTypeName: string;
  enabled: boolean;
  statusName: string;
  productConditionId: number;
  addedInCreation?: boolean;
  conditionId?: number;
}

export interface KitsForTicket {
  kitId: number;
  kitName: string;
}

export interface TicketComponentResponse {
  ticketId: number;
  products: ProductForTicket[];
  supplies: SupplyForTicket[];
  kitsInstalled: KitsForTicket[];
  hasComponents: boolean;
}

export interface GetProductsForShipmentResponse {
  productId?: number;
  shipmentItemId?: number;
  serialNumber?: string;
  productBrand?: string;
  productModel?: string;
  productModelDescription?: string;
  productStatus?: string;
  productCondition?: string;
  productAgreementAccepted?: null;
  stockNumber?: string;
}

export interface SendComponentToLaboratoryPayload {
  productId: number;
  comment: string;
}

export interface MassiveAssignComponentToLabTechnicianRequest {
  productIds: number[];
  responsibleId: number;
}

export interface UpdateProductToSentToWarehouse {
  productId: number;
  reparationTypeId: number;
  comment: string;
  credential: string;
}

export interface UpdateProductToPendingPerPart {
  productId: number;
  comment: string;
}

export interface UpdateProductToRecycling {
  productId: number;
  comment: string;
}

export interface UpdateProductToOnReviewRequest {
  productId: number;
  comment: string;
}

export interface UpdateProductToRepairedBySupplier {
  productIds: number[];
}

export interface UpdateProductToAvailableRequest {
  productId: number;
  comment: string;
}

export interface UpdateProductsToAvailableRequest {
  productIds: number[];
}

export interface UpdateProductToDamaged {
  productId: number;
  comment: string;
  credential: string;
}

export interface UpdateProductToScrap {
  productId: number;
  irreparableReasonId: number;
  credential: string;
}

export interface IrreparableReasonUpdateRequest {
  irreparableReasonId: number;
  description: string;
  enabled: boolean;
}

export interface IBulkReceiveComponents {
  acceptedProductIds?: number[];
  rejectedProductIds?: number[];
  responsibleId?: number;
}

export interface MassiveAssignComponentToLabTechnicianPayload {
  productIds: number[];
  responsibleId: number;
}

export interface LaboratoryTechnicians {
  fullName: string;
  id: number;
  responsibleId: number;
  warehouseId: number;
  warehouseLabResponsibleId: number;
}

export interface GetLaboratoryTechniciansParams {
  warehouseLabResponsibleId: number;
  text?: string;
  orderColumn?: string;
  descending?: boolean;
  enabled?: boolean;
}

export interface ReasignConfigComponentsComponentsRequest {
  ProductIds: number[];
  responsibleId: number;
}

export interface BulkLoadKit {
  clientName: string;
  responsibleName: string;
  description: string;
  index: number;
}

export interface BulkLoadKitPayload {
  kits: BulkLoadKit[];
  withoutSaving: boolean;
}

export interface ErrorKit {
  index: number;
  errorMsg: string;
}

export interface AddedKit {
  index: number;
  clientName: string;
  responsibleName: string;
  description: string;
  successKitId: number;
  createdDate: string;
}

export interface BulkLoadKitResponse {
  errorKits: ErrorKit[];
  addedKits: AddedKit[];
  createdDateTimeUTC: string;
  withoutSaving: boolean;
}

export interface KitProduct {
  index: number;
  kitName: string;
  serialNumber: string;
}

export interface BulkLoadProductKitsPayload {
  kitProducts: KitProduct[];
  withoutSaving: boolean;
}

export interface ErrorKitProduct {
  index: number;
  errorMsg: string;
}

export interface AddedKitProduct {
  index: number;
  kitName: string;
  serialNumber: string;
  responsibleName: string;
  productModelName: string;
  productBrandName: string;
  createdDate: string;
  clientName: string;
  createdUserName: string;
}

export interface BulkLoadProductKitsResponse {
  errorKitProducts: ErrorKitProduct[];
  addedKitProducts: AddedKitProduct[];
  createdDateTimeUTC: string;
  withoutSaving: boolean;
}

export interface UpdateProductToWorkToolRequest {
  productIds: number[];
  comment: string;
}

/* API */

export default {
  instance,
  supplies: {
    /** Original supplies */
    /**
     * GET all supplies
     *
     * @tags Supply
     * @name GetAllSupply
     * @request GET:/api/v1/Supply
     * @secure
     */
    GetAllSupply: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Supply`,
        method: 'GET',
        ...config
      }),
    /**
     * Supplies For Shipment
     * @tags Supplies
     * @name GetSuppliesForShipment
     * @request POST:/api/v1/Supply/GetSuppliesForShipment
     * @secure
     */
    GetSuppliesForShipment: (data: unknown, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<ProductSearched>>>({
        url: `/Supply/GetSuppliesForShipment`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Search Supplies
     * @tags Supplies
     * @name GeneralSearch
     * @request POST:/api/v1/Supply/GeneralSearch
     * @secure
     */
    supppliesGeneralSearch: (
      data: SearchSuppliesParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<ProductSearched>>>({
        url: `/Supply/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Crea Insumos
     *
     * @tags Supply
     * @name createSupplyStock
     * @request POST:/api/v1/Supply
     * @secure
     */
    createSupply: (
      data: SuppliesOriginalRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Supply`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Edita las existencias de Insumos
     *
     * @tags Supply
     * @name editSupply
     * @request POST:/api/v1/Supply
     * @secure
     */
    editSupply: (
      data: SuppliesOriginalRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Supply`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * DELETE
     * @tags Supply
     * @name DELETE
     * @request DELETE:/api/v1/Supply/{id}
     * @secure
     */
    deleteSupply: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Supply/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  products: {
    /**
     * TRAE TODOS LOS COMPONENTES QUE ESTAN ASIGNADOS AL CLIENTE PERO NO DISTINGUE POR ESTADOS
     *
     * @tags Products
     * @name list
     * @request GET:/api/v1/Products
     * @secure
     */
    list: (
      params: { ClientId: number; PageNumber?: number; PageSize?: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<Product[]>>({
        url: `/Products`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * RETORNA EL DETALLE DEL PRUDUCTO
     *
     * @tags Products
     * @name getForTicketAsignationList
     * @request GET:/api/v1/Products/GetForTicketAsignation
     * @secure
     */
    getForTicketAsignationList: (
      params: { ClientId: number; SerialNumber: string },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<Product[]>>({
        url: `/Products/GetForTicketAsignation`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * TRAE LOS COMPONENTES QUE ESTAN ASIGNADO AL CLIENTE Y AL USUARIO
     *
     * @tags Products
     * @name getAllForTicketAsignationByClientAndResponsibleId
     * @request GET:/api/v1/Products/GetAllForTicketAsignationByClientAndResponsibleId
     * @secure
     */
    getAllForTicketAsignationByClientAndResponsibleId: (
      queryParams: { clientId: number; responsibleId: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ProductItem[]>>({
        url: `/Products/GetAllForTicketAsignationByClientAndResponsibleId`,
        params: queryParams,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE TODOS LOS COMPONENTES QUE ESTAN ASIGNADOS AL CLIENTE PERO NO DISTINGUE POR INGENIERO QUE SE PUEDEN INSTALAR
     *
     * @tags Products
     * @name getAllForTicketAsignationByClientIdDetail
     * @request GET:/api/v1/Products/GetAllForTicketAsignationByClientId/{clientId}
     * @secure
     */
    getAllForTicketAsignationByClientIdDetail: (
      clientId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ProductItem[]>>({
        url: `/Products/GetAllForTicketAsignationByClientId/${clientId}`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE LOS COMPONENTES YA INSTALADOS
     *
     * @tags Products
     * @name getAllForTicketAsignationByLocationIdDetail
     * @request GET:/api/v1/Products/GetAllForTicketAsignationByLocationId/{locationId}
     * @secure
     */
    getAllForTicketAsignationByLocationIdDetail: (
      locationId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ProductItem[]>>({
        url: `/Products/GetAllForTicketAsignationByLocationId/${locationId}`,
        method: 'GET',
        ...config
      }),
    /**
     * Tickets by Location
     * @tags Tickets
     * @name getTicketsByProductId
     * @request GET:/api/v1/Tickets/GetTicketsByProductId?ProductId={ProductId}
     * @secure
     */
    getTicketsByProductId: (
      params: TicketsByLocationParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<TicketsByLocationResponse>>
      >({
        url: `/Tickets/GetTicketsByProductId`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * TRAE LOS COMPONENTES A INSTALAR
     *
     * @tags Products
     * @name getAllForAsignationByClientAndUserId
     * @request GET: /v1/Products/GetAllForAsignationByClientAndUserId
     * @secure
     */
    getAllForAsignationByClientAndUserId: (
      queryParams: {
        clientId: number;
        responsibleId: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<SearchProductsByClientResponse[]>
      >({
        url: `/Products/GetAllForAsignationByClientAndUserId`,
        method: 'GET',
        params: queryParams,
        ...config
      }),

    /**
     * No description
     *
     * @tags Products
     * @name detail
     * @request GET:/api/v1/Products/{id}
     * @secure
     */
    detail: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Product>>({
        url: `/Products/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Post Products
     * @tags Products
     * @name create
     * @request POST:/api/v1/Products
     * @secure
     */
    create: (data: ProductPost, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ProductPost>>({
        url: `/Products`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * PUT Products
     * @tags Products
     * @name update
     * @request PUT:/api/v1/Products
     * @secure
     */
    update: (data: ProductPost, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Products`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * PUT Products
     * @tags Products
     * @name DELETE
     * @request DELETE:/api/v1/Products/{id}
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Products/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Search Products By Client
     * @tags Products
     * @name searchProductsByClient
     * @request POST:/api/v1/Products/SearchProductsByClient
     * @secure
     */
    searchProductsByClient: (
      data: SearchProductsByClientParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<ProductSearched>>>({
        url: `/Products/SearchProductsByClient`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * GEOLOCATION OF CONFIG COMPONENTS BY RESPONSIBLE ID
     * @tags Products
     * @name getGeoLocationOfConfigComponents
     * @request POST:/api/v1/Products/ProductsLocationFilter
     * @secure
     */
    getGeoLocationOfConfigComponents: (
      data: GeoProductsRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<GeoProductsResponse[]>>({
        url: `/Products/ProductsLocationFilter`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Carga masiva de productos
     * @tags Products
     * @name BulkLoadProducts
     * @request POST:/api/v1/Products/BulkLoadProducts
     * @secure
     */
    bulkLoadProducts: (
      data: ProductMassiveLoad,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<BulkLoadProductsResponse>>({
        url: `/Products/BulkLoadProducts`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Actualización masiva de productos
     * @tags Products
     * @name bulkUpdateProducts
     * @request POST:/api/v1/Products/BulkUpdateProducts
     * @secure
     */
    bulkUpdateProducts: (
      data: { products: ProductMassiveUpdate[] },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<BulkLoadProductsResponse>>({
        url: `/Products/BulkUpdateProducts`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Obtiene datos de compenente de configuración
     *
     * @tags GetProductsForShipment
     * @name GetProductsForShipment
     * @request GET:/api/v1/Products/GetProductsForShipment?{params}
     * @secure
     */
    GetProductsForShipment: (
      params: GetParamsProduct,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<GetProductsForShipmentResponse[]>
      >({
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        url: `/Products/GetProductsForShipment`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * Obtiene datos de compenente de configuración
     *
     * @tags KitsForShipment
     * @name KitsForShipment
     * @request GET:/api/v1/Kits/KitsForShipment?{params}
     * @secure
     */
    KitsForShipment: (
      params: GetParamsProduct,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        url: `/Kits/KitsForShipment`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags ProductStatus
     * @name updateProductToSentToWarehouse
     * @request PUT:/api/v1/Products/UpdateProductToSentToWarehouse
     * @secure
     */
    updateProductToSentToWarehouse: (
      data: UpdateProductToSentToWarehouse,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Products/UpdateProductToSentToWarehouse`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name updateProductToPendingPerPart
     * @request PUT:/api/v1/Products/UpdateProductToPendingPerPart
     * @secure
     */
    updateProductToPendingPerPart: (
      data: UpdateProductToPendingPerPart,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Products/UpdateProductToPendingPerPart`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name updateProductToRecycling
     * @request PUT:/api/v1/Products/UpdateProductToRecycling
     * @secure
     */
    updateProductToRecycling: (
      data: UpdateProductToRecycling,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Products/UpdateProductToRecycling`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name UpdateProductToRepairedBySupplier
     * @request PUT:/api/v1/Products/UpdateProductToRepairedBySupplier
     * @secure
     */
    updateProductToRepairedBySupplier: (
      data: UpdateProductToRepairedBySupplier,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Products/UpdateProductsToRepairedBySupplier`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name updateProductToDamaged
     * @request PUT:/api/v1/Products/UpdateProductToDamaged
     * @secure
     */
    updateProductToDamaged: (
      data: UpdateProductToDamaged,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Products/UpdateProductToDamaged`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name updateProductToScrap
     * @request PUT:/api/v1/Products/UpdateProductToScrap
     * @secure
     */
    updateProductToScrap: (
      data: UpdateProductToScrap,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Products/UpdateProductToScrap`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name UpdateProductToAvailable
     * @request PUT:/api/v1/Products/UpdateProductToAvailable
     * @secure
     */
    UpdateProductToAvailable: (
      data: UpdateProductToAvailableRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Products/UpdateProductToAvailable`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name UpdateProductsToAvailable
     * @request PUT:/api/v1/Products/UpdateProductsToAvailable
     * @secure
     */
    UpdateProductsToAvailable: (
      data: UpdateProductsToAvailableRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Products/UpdateProductsToAvailable`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name UpdateProductToOnReview
     * @request PUT:/api/v1/Products/UpdateProductToOnReview
     * @secure
     */
    UpdateProductToOnReview: (
      data: UpdateProductToOnReviewRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Products/UpdateProductToOnReview`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name updateProductToWorkTool
     * @request PUT:/api/v1/Products/UpdateProductToWorkTool
     * @secure
     * @description Actualiza el estado de un producto a herramienta de trabajo
     */
    updateProductToWorkTool: (
      data: UpdateProductToWorkToolRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Products/UpdateProductsToWorkTool`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags Products
     * @name updateProductsToOnReview
     * @request PUT:/api/v1/Products/UpdateProductsToOnReview
     * @secure
     * @description Actualiza el estado de un producto a en revisión
     */
    updateProductsToOnReview: (
      data: MassiveAssignComponentToLabTechnicianRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Products/UpdateProductsToOnReview`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name productHealthCheck
     * @request POST:/api/v1/Products/ProductHealthCheck
     * @secure
     * @description Actualiza el estado de un producto a herramienta de trabajo
     */

    productHealthCheck: (
      data: {
        productId: number;
        ticketId: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Products/ProductHealthCheck`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags Products
     * @name GetForProblems
     * @request POST:/api/v1/Products/GetForProblems
     * @secure
     * @description Obtiene productos filtrando por número de serie para asignar a problemas
     */

    GetForProblems: (
      clientId: number,
      text: string,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<SearchProductsByClientResponse[]>
      >({
        url: `/Products/GetForProblems/${clientId}`,
        method: 'GET',
        params: { Text: text },
        ...config
      }),
    /**
     * @tags Products
     * @name GetForReleases
     * @request POST:/api/v1/Products/GetForReleases
     * @secure
     * @description Obtiene productos filtrando por número de serie para asignar a releases
     */

    GetForReleases: (
      params: {
        text: string;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<SearchProductsByClientResponse[]>
      >({
        url: `/Products/GetForReleases`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags Products
     * @name updateProductToDamagedClientProperty
     * @request POST:/api/v1/Products/UpdateProductToDamagedClientProperty
     * @secure
     * @description Actualiza producto a Irreparable/Dañado - Propiedad del Cliente
     */

    updateProductToDamagedClientProperty: (
      data: UpdateProductToScrap,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Products/UpdateProductToDamagedClientProperty`,
        method: 'PUT',
        data,
        ...config
      })
  },
  configComponentsLoogBook: {
    /**
     * @tags configComponentsLoogBook
     * @name getConfCompLoogBook
     * @request POST:/api/v1/Products/ProductTrackingList
     * @secure
     */
    getConfCompLoogBook: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<IConfigComponentLoogBook>>
      >({
        url: `/Products/ProductTrackingList`,
        method: 'POST',
        data,
        ...config
      })
  },
  kits: {
    /**
     * @tags Inventories
     * @name generalSearchOfKits
     * @request POST: /api/v1/Kits/SearchKits
     * @secure
     */
    generalSearchOfKits: (
      data: IParamsFilter,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GeneralSearchKitResponse[]>>
      >({
        url: `/Kits/SearchKits`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags Inventories
     * @name generalSearchOfConfigComponentsOfAKit
     * @request GET: /api/v1/Kits/Components/2
     * @secure
     */
    generalSearchOfConfigComponentsOfAKit: (
      id: number,
      params: IParamsFilter,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<KitProductRequest[]>>
      >({
        url: `/Kits/Components/${id}`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags Inventories
     * @name CreateNewKits
     * @request POST: /api/v1/Kits
     * @secure
     */
    CreateNewKits: (data: NewKitRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Kits`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags Inventories
     * @name AddNewConfigComponentsToAKit
     * @request POST: /api/v1/Kits/AddComponentsToKit
     * @secure
     */
    AddNewConfigComponentsToAKit: (
      data: AddNewConfigComponentsToAKit,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Kits/AddComponentsToKit`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags Inventories
     * @name DeleteConfigComponentsToAKit
     * @request PUT: /api/v1/Kits/RemoveComponentFromKit
     * @secure
     */
    DeleteConfigComponentsToAKit: (
      data: DeleteConfigComponentsToAKit,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Kits/RemoveComponentFromKit`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags Inventories
     * @name EditNewKits
     * @request PUT: /api/v1/Kits
     * @secure
     */
    EditNewKits: (data: EditKitRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Kits`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags Inventories
     * @name DeleteKit
     * @request DELETE: /api/v1/Kits/1
     * @secure
     */
    DeleteKit: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Kits/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * TRAE LOS COMPONENTES DE CONFIGURACION PARA PODER ASOCIARLOS A UN KIT POR CLIENT ID
     *
     * @tags Inventories
     * @name GetAllConfigComponent
     * @request GET: /api/v1/Products/GetForKitAssignation/105
     * @secure
     */
    GetAllConfigComponent: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<AllProductForAKitResponse[]>>(
        {
          url: `/Products/GetForKitAssignation/${id}`,
          method: 'GET',
          ...config
        }
      ),
    /**
     * LoogBock de un kit
     *
     * @tags Inventories
     * @name GetLoogBooksOfAKit
     * @request GET: /api/v1/Kits/Tracking?KitId=2
     * @secure
     */
    GetLoogBooksOfAKit: (
      params: KitLoogBookParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<KitLoogBookResponse[]>>
      >({
        url: `Kits/Tracking`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * TRAE LOS ESTADOS DE UN KIT
     * @tags Inventories
     * @name GetAllKitStatus
     * @request GET: /api/v1/Kits/GetAllStatuses
     * @secure
     */
    GetAllKitStatus: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<KitStatusResponse[]>>({
        url: `Kits/GetAllStatuses`,
        method: 'GET',
        ...config
      }),

    /**
     * Carga masiva de Kits
     * @tags Kits
     * @name BulkLoadKits
     * @request POST: /api/v1/Kits/BulkLoadKits
     * @secure
     */
    BulkLoadKits: (data: BulkLoadKitPayload, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<BulkLoadKitResponse>>({
        url: `Kits/BulkLoadKits`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Carga masiva de Productos a Kits
     * @tags Kits
     * @name BulkLoadProductKits
     * @request POST: /api/v1/Kits/BulkLoadProductKits
     * @secure
     */
    BulkLoadProductKits: (
      data: BulkLoadProductKitsPayload,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<BulkLoadProductKitsResponse>>(
        {
          url: `Kits/BulkLoadProductKits`,
          method: 'POST',
          data,
          ...config
        }
      )
  },
  tickets: {
    /**
     * @tags Tickets
     * @name getTicketComponentsByTicketId
     * @request GET: /api/v1/Tickets/GetTicketComponentsByTicketId
     * @secure
     */
    getTicketComponentsByTicketId: (
      id: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<TicketComponentResponse>>({
        url: `/Tickets/GetTicketComponentsByTicketId`,
        method: 'GET',
        params: { id },
        ...config
      })
  },
  laboratories: {
    /**
     * @tags Laboratories
     * @name SendComponentToLaboratory
     * @description Envía un componente con estatus "En revisión" al laboratorio y lo pasa a "Envío a Laboratorio"
     * @request POST: /api/v1/Laboratories/SendComponentToLaboratory
     * @secure
     */
    SendComponentToLaboratory: (
      data: SendComponentToLaboratoryPayload,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<{ message: string }>>({
        url: `/Laboratories/SendComponentToLaboratory`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags Laboratories
     * @name GetLaboratoryTechnicians
     * @description Obtiene los técnicos de laboratorio por usuario y laboratorio
     * @request GET: /api/v1/Laboratories/GetLaboratoryTechnicians
     * @secure
     */
    GetLaboratoryTechnicians: (
      params: GetLaboratoryTechniciansParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<LaboratoryTechnicians[]>>({
        url: `/Laboratories/GetLaboratoryTechnicians`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * @tags Laboratories
     * @name MassiveAssignComponentToLabTechnician
     * @description Asigna masivamente componentes con estatus "En laboratorio"
     * y los pasas a "En revisión" con un técnico de laboratorio asignado
     * @request POST: /api/v1/Laboratories/MassiveAssignComponentToLabTechnician
     * @secure
     */
    MassiveAssignComponentToLabTechnician: (
      data: MassiveAssignComponentToLabTechnicianPayload,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<{ message: string }>>({
        url: `/Laboratories/MassiveAssignComponentToLabTechnician`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags Laboratories
     * @name BulkReceiveComponents
     * @description Acepta o rechaza de forma masiva componentes con estatus
     * "En traslado a laboratorio" y los pasa a "En revisión" o "Rechazado por laboratorio"
     * @request POST: /api/v1/Laboratories/BulkReceiveComponents
     * @secure
     */

    BulkReceiveComponents: (
      data: IBulkReceiveComponents,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Laboratories/BulkReceiveComponents`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags Laboratories
     * @name ReasignConfigComponentsComponents
     * @description Reasigna el Ingeniero asociados al componente de configuración
     * @request POST: /api/v1/Laboratories/ReassingLabTechnician
     * @secure
     */

    ReasignConfigComponentsComponents: (
      data: ReasignConfigComponentsComponentsRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Laboratories/ReassingLabTechnician`,
        method: 'POST',
        data,
        ...config
      })
  }
};
